export enum FLAG_TYPES {
  DISEASE_TYPE= 'primary_cancer',
  DATA_TOGGLE= 'changed',
  CANCER= 'cancer',
  STATUS= 'status',
  ACTION_TITLE= 'actionTitle',
  TAB_CLOSABLE= 'closeable',
  CREATION_DATE= 'creationDate',
  FORM_ID= 'formId'
}
export enum TAGS {
  TAG_MODIFIED = '_df_modified'
}

